import { baseResources, baseResourceActions } from "routes/enum";

const {
    AGENTS_INBOX,
    TICKET_FILTER_EMAIL,
    TICKET_FILTER_AGENT,
    TICKET_THIRD_PARTY_EMAIL,
    TICKET_MENTION,
    TICKET_CANNED_RESPONSE_SEND,
    TICKET_POST_FORM_SEND,
    TICKET_AGENT_ASSISTANT,
    TICKET_SNOOZE,
    TICKET_READ_STATUS,
    TICKET_CLOSE,
    TICKET_ATTACHMENT,
    TICKET_CUSTOM_STATUS,
} = baseResources;

const { READ, CREATE, UPDATE } = baseResourceActions;

/** View agent inbox */
export const INBOX_READ_PERMISSION = [`${READ}_${AGENTS_INBOX}`];

/** Filter tickets by email */
export const TICKET_FILTER_EMAIL_PERMISSION = [`${READ}_${TICKET_FILTER_EMAIL}`];

/** Filter tickets by agents (see other agents' inboxes) */
export const TICKET_FILTER_AGENT_PERMISSION = [`${READ}_${TICKET_FILTER_AGENT}`];

/** Send third party e-mail */
export const TICKET_THIRD_PARTY_EMAIL_PERMISSION = [
    `${CREATE}_${TICKET_THIRD_PARTY_EMAIL}`,
];

/** Post a mention */
export const TICKET_MENTION_PERMISSION = [`${CREATE}_${TICKET_MENTION}`];

/** Send a canned response */
export const TICKET_CANNED_RESPONSE_SEND_PERMISSION = [
    `${CREATE}_${TICKET_CANNED_RESPONSE_SEND}`,
];

/** Send a post-form */
export const TICKET_POST_FORM_SEND_PERMISSION = [
    `${CREATE}_${TICKET_POST_FORM_SEND}`,
];

/** Access agent's assistant */
export const TICKET_AGENT_ASSISTANT_PERMISSION = [
    `${READ}_${TICKET_AGENT_ASSISTANT}`,
];

/** Snooze ticket */
export const TICKET_SNOOZE_PERMISSION = [`${UPDATE}_${TICKET_SNOOZE}`];

/** Mark ticket as read */
export const TICKET_READ_STATUS_PERMISSION = [`${UPDATE}_${TICKET_READ_STATUS}`];

/** Close ticket */
export const TICKET_CLOSE_PERMISSION = [`${UPDATE}_${TICKET_CLOSE}`];

/** Add an attachment */
export const TICKET_ATTACHMENT_PERMISSION = [`${CREATE}_${TICKET_ATTACHMENT}`];

/** Assign custom ticket status on a ticket */
export const TICKET_CUSTOM_STATUS_ASSIGN_PERMISSION = [
    `${UPDATE}_${TICKET_CUSTOM_STATUS}`,
];

export const TICKET_MANAGEMENT_PERMISSION_MAP = {
    "View agent inbox": INBOX_READ_PERMISSION,
    "Filter tickets by email": TICKET_FILTER_EMAIL_PERMISSION,
    "Filter tickets by agents (see other agents' inboxes)":
        TICKET_FILTER_AGENT_PERMISSION,
    "Send third party e-mail": TICKET_THIRD_PARTY_EMAIL_PERMISSION,
    "Post a mention": TICKET_MENTION_PERMISSION,
    "Send a canned response": TICKET_CANNED_RESPONSE_SEND_PERMISSION,
    "Send a post-form": TICKET_POST_FORM_SEND_PERMISSION,
    "Access agent's assistant": TICKET_AGENT_ASSISTANT_PERMISSION,
    "Snooze ticket": TICKET_SNOOZE_PERMISSION,
    "Mark ticket as read": TICKET_READ_STATUS_PERMISSION,
    "Close ticket": TICKET_CLOSE_PERMISSION,
    "Add an attachment": TICKET_ATTACHMENT_PERMISSION,
    "Assign custom ticket status": TICKET_CUSTOM_STATUS_ASSIGN_PERMISSION,
};
